Ext.define('SA.StorageJsonEntry', {
    constructor({key, storage}) {
        this.key = key;
        this.storage = storage;
    },

    getValue() {
        var value = this.storage.get(this.key);

        return SA.String.isString(value) ? JSON.parse(value) : null;
    },

    setValue(value) {
        this.storage.set(this.key, JSON.stringify(value));
    }
});